import { CompletionRule } from '../enums/completion-rule.enum';
import { BookingApprovalType } from '../enums/booking-approval-type.enum';
import { CourseOffering } from './course-offering.model';

export class UpdateCourseOfferingCommand {
    name: string;
    sort: number;
    offering_group: { id: string };
    product_code: string;
    completion_rule: CompletionRule;
    booking_approval_type: BookingApprovalType;
    booking_url: string;
    language: string;
    content_type: {
        id: number;
    };
    price: {
        amount: number | null;
        currency: string | null;
    };

    constructor(courseOffering: CourseOffering) {
        this.name = courseOffering.name;
        this.sort = courseOffering.sort;
        this.offering_group = courseOffering.offeringGroup ? courseOffering.offeringGroup : null;
        this.product_code = courseOffering.productCode;
        this.completion_rule = courseOffering.completionRule;
        this.booking_approval_type = courseOffering.bookingApprovalType;
        this.booking_url = courseOffering.bookingUrl;
        this.language = courseOffering.language;
        this.content_type = {
            id: Number(courseOffering.contentType.id),
        };
        this.price = {
            amount: courseOffering?.price?.amount !== null && courseOffering?.price?.amount !== undefined ? Number(courseOffering.price.amount) : null,
            currency: courseOffering?.price?.currency || null,
        };
    }
}
